angular.module("app").controller("SkinGamesEditPageController", [
    '$scope',
    '$filter',
    'casinoGameService',
    'errorHandler',
    'preloadedCategories',
    'logger',
    'preloadedGameData',
    'deepCompare',
    'markets',
    '$timeout',
    '$uibModalInstance',
    'casinoSkinGameTypes',
    'casinoLabels',
    'isLicense',
    'hasCasinoBetLimits',
    'hasCasinoRegulationInfo',
    'casinoImageType',
    'currencies',
    function ($scope, $filter, casinoGameService, errorHandler, preloadedCategories, logger, preloadedGameData, deepCompare, markets, $timeout, $modalInstance, casinoSkinGameTypes, casinoLabels, isLicense, hasCasinoBetLimits,hasCasinoRegulationInfo, casinoImageType, currencies) {
        var init, addElementHelper = null, types= [], translator = $filter('translate');
        var preSelectedCategores;
        casinoSkinGameTypes.forEach(function (value) {
            types.push({
                id: value,
                title: translator('casinoGame.addEdit.types.' + value)
            })
        });
        preloadedGameData.badge = preloadedGameData.badge || "";
        preloadedGameData.markets = preloadedGameData.markets || {available: []};

        $scope.tooltip = {
            name: "",
            height: "",
            width: "",
            downloadLinkWindows: "",
            downloadLinkLinux: "",
            downloadLinkMac: ""
        };
        $scope.isLicense = isLicense;
        $scope.hasCasinoBetLimits = hasCasinoBetLimits;
        $scope.hasCasinoRegulationInfo = hasCasinoRegulationInfo;

        console.log(hasCasinoRegulationInfo)


        $scope.currencies = hasCasinoBetLimits ? currencies.data.map(function(item){
            return {id: item.key, title: item.value}
        }) : [];
        $scope.casinoImageType = casinoImageType;
        $scope.casinoLabels = casinoLabels;
        $scope.show_on_page = angular.copy(['home']); //Will be changed
        var marketTitleIdMap = {};
        var marketIdTitleMap = {};
        var initialSelectedMarkets = [];
        var isChangedMarkets = false;
        var casinoGameTypeIdMap = {};
        var casinoGameIdTypeMap = {};
        var preselectedTypes = [];
        var deletedIds = [];

        $scope.dropdownOptions = {
            defaults: []
        };

        $scope.selectDefaultImages = function (section) {
            if (section.icon) {
                $scope.selectedIconDefaultId = section.icon;

                if ($scope.selectedIconDefaultId !== preloadedIconDefaultId && $scope.selectedIconDefaultId > 0) { // uploads has negative ids
                    $scope.gameData.icon_id = $scope.selectedIconDefaultId
                } else {
                    delete $scope.gameData.icon_id;
                }

            } else if (section.background) {

                $scope.selectedBackgroundDefaultId = section.background;

                if ($scope.selectedBackgroundDefaultId !== preloadedBackgroundDefaultId) {
                    $scope.gameData.background_id = $scope.selectedBackgroundDefaultId
                } else {
                    delete $scope.gameData.background_id;
                }
            }
        };

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            $timeout(resetDefaultDropdown)
        };

        /**
         * Extract needed data from game response
         * @param game
         */
        function extractGame(game) {
            if (!game.background) {
                var image = null;
                if (!!game["icon_1"]) {
                    image = game["icon_1"];
                } else if (!!game["icon_2"]) {
                    image = game["icon_2"];
                } else if (!!game["icon_3"]) {
                    image = game["icon_3"];
                }

                if (game.default) {
                    $scope.selectedIconDefaultId = preloadedIconDefaultId = game.id;
                }
                return {
                    global: game.global,
                    src: image,
                    id: game.id
                }
            }
            else {
                if (game.default) {
                    $scope.selectedBackgroundDefaultId = preloadedBackgroundDefaultId = game.id;
                }
                return {
                    background: game.background,
                    id: game.id
                }
            }
        }

        $scope.save = function () {
            if (!$scope.edit_games_form.$valid) {
                return;
            } else if ($scope.isAllowedToUpdate()){
                logger.logError("global.no_changes");
                return;
            }
            addElementHelper = addElementHelper || $scope.useAddElementHelper();
            var fetchedData = fetchRequestData(),
                requestData = {
                    skinGame: angular.copy(fetchedData)
                };
            delete requestData.backgrounds;
            delete requestData.icons;
            requestData.skinGame.id = requestData.skinGame.gameSkinId;
            delete requestData.skinGame.gameSkinId;
            casinoGameService.editSkinGameFull(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedGameData = angular.copy(fetchedData);
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            var requestData = fetchRequestData();
            var result = true;

            if(!deepCompare.isEqual(preSelectedCategores, requestData.categories)){
                result = false;
            }
            requestData.categories = preloadedGameData.categories;
            var types = [];
            preselectedTypes.forEach(function (value) {
               types.push(casinoGameTypeIdMap[value]);
            });
            result = result && deepCompare.isEqual(types, requestData.types);
            delete requestData.types;
            result = result && deepCompare.isEqual(requestData, preloadedGameData);
            return result;
        };

        function fetchRequestData () {
            addElementHelper = addElementHelper || ($scope.useAddElementHelper && $scope.useAddElementHelper());
            var fetchedData = angular.extend({}, $scope.gameData);
            fetchedData.types = [];
            fetchedData.markets.available = [];
            $scope.multiSelect.selectedMarkets.forEach(function (value) {
                fetchedData.markets.available.push(marketTitleIdMap[value]);
            });

            $scope.multiSelect.selectedCasinoGameTypes.forEach(function (value) {
                fetchedData.types.push(casinoGameTypeIdMap[value]);
            });

            fetchedData.categories = addElementHelper && addElementHelper.fetchData('selectedCategories');

            if ($scope.icons) {
                fetchedData.customIcons = $scope.icons.filter(function (icon) {
                    return icon.src.indexOf('data:image') !== -1;
                }).map(function (icon) {
                    return {
                        icon: icon.src,
                        default: icon.id === $scope.selectedIconDefaultId,
                        id: icon.id > 0 ? icon.id : undefined
                    }
                });
            }

            var betLimits = Object.entries(addElementHelper.fetchData('betLimits') || {});
            if(betLimits.length){
                fetchedData.bet_limits = {};
                betLimits.forEach(function(item){
                    var limits = item[1].split("-");
                    var min = limits[0];
                    var max = limits[1];
                    fetchedData.bet_limits[item[0]] = {min: min, max: max};
                });
            }else {
               fetchedData.bet_limits = null;
            }


            if(deletedIds.length){
                fetchedData.deletedIds = deletedIds;
            }

            return fetchedData
        }

        $scope.resetDefaultDropdown = function resetDefaultDropdown () {
            $scope.dropdownOptions.defaults = [];

            $scope.multiSelect.selectedMarkets.forEach(function (market) {
                $scope.dropdownOptions.defaults.push(getMarketByKey(marketTitleIdMap[market]))
            });
            if(!isChangedMarkets && initialSelectedMarkets.length !==  $scope.multiSelect.selectedMarkets.length) {
                isChangedMarkets = true;
            }
            isChangedMarkets && ($scope.gameData.markets.default = (($scope.dropdownOptions.defaults[0] || {})['key']));
        }

        function getMarketByKey (id) {
            for (var i = 0, length = $scope.multiSelect.markets.length; i < length; i++) {
                if ($scope.multiSelect.markets[i].key == id) {
                    return angular.copy($scope.multiSelect.markets[i])
                }
            }
        }

        $scope.isMarketSelected = function () {
            return !!$scope.multiSelect.selectedMarkets.length
        };

        $scope.isEnabeledToChange = function (prop) {
            return preloadedGameData.hasOwnProperty(prop);
        };

        (init = function (gameData) {
            $scope.multiSelect = {markets: angular.copy(markets)};
            $scope.multiSelect.marketTitles = angular.copy(markets).map(function (market) {
               marketIdTitleMap[market.key] = market.value;
               marketTitleIdMap[market.value] = market.key;
               return market.value;
            });
            $scope.multiSelect.selectedMarkets =  ((gameData.markets && gameData.markets.available) ? gameData.markets.available : []).map(function (value) {
                return marketIdTitleMap[value];
            });
            $scope.multiSelect.selectedCasinoGameTypes = [];
            $scope.disabledTypes = {};
            $scope.multiSelect.casinoGameTypeTitles = types.map(function (item) {
                casinoGameTypeIdMap[item.title] = item.id;
                casinoGameIdTypeMap[item.id] = item.title;
                if(gameData[item.id] === undefined){
                    $scope.disabledTypes[item.title] = true;
                } else if(gameData[item.id] === "1"){
                    $scope.multiSelect.selectedCasinoGameTypes.push(item.title);
                }
                return item.title;
            });
            preselectedTypes  = angular.copy($scope.multiSelect.selectedCasinoGameTypes);
            initialSelectedMarkets = angular.copy($scope.multiSelect.selectedMarkets);

            $scope.categories = angular.copy(preloadedCategories);

            $scope.selectedCategories = (function () {
                var fetchedData = {};
                gameData.categories.forEach(function (category) {
                    fetchedData[category.id] = category.expiration_date || '';
                });
                return fetchedData
            })();

            if(gameData.bet_limits){
                var betLimits = {};

                Object.entries(gameData.bet_limits).forEach(function(item){
                    betLimits[item[0]] = item[1].min+ "-" + item[1].max;
                })

                $scope.betLimits = betLimits;
            }

            preSelectedCategores = angular.copy($scope.selectedCategories);
            if (Object.keys(preSelectedCategores).length === 0) {
                preSelectedCategores = undefined;
            }

            gameData.categories = angular.copy($scope.categories);
            gameData.show_on_page = gameData.show_on_page || [];
            $scope.gameData = angular.copy(gameData);
            $scope.resetDefaultDropdown();
            if (preloadedGameData.markets && preloadedGameData.markets.default) {
                $scope.gameData.markets.default = preloadedGameData.markets && preloadedGameData.markets.default;
            }
            $scope.backgrounds = angular.copy(preloadedGameData.backgrounds || []).map(extractGame);
            if ($scope.isLicense) {
                $scope.licenseIcons = preloadedGameData.licenseIcons? angular.copy(preloadedGameData.licenseIcons || []).map(extractGame):[];
            } else {
                $scope.icons = angular.copy(preloadedGameData.icons || []).map(extractGame);
                $scope.uploadCache = {
                    icon: [],
                    customIcon: [],
                };

                $scope.deleteIcon = function (id) {
                    var deleteIndex = $scope.icons.findIndex(function (icon){
                        return icon.id === id;
                    });

                    var selectedIndex = $scope.icons.findIndex(function (icon){
                        return icon.id === $scope.selectedIconDefaultId;
                    });

                    $scope.icons.splice(deleteIndex, 1);
                    if ($scope.selectedIconDefaultId === id) {
                        $scope.selectedIconDefaultId = $scope.icons[0].id;
                    } else if (selectedIndex > deleteIndex) {
                        $scope.selectedIconDefaultId = $scope.icons[selectedIndex - 1].id;
                    }

                    if(id && id > 0) { // negative ids teporary for uploades
                        deletedIds.push(id);
                    };
                };

                $scope.$watch('uploadCache.icon', function () {
                    if ($scope.uploadCache.icon && angular.isString($scope.uploadCache.icon)) {
                        var newIcon = {src: $scope.uploadCache.icon, global: false, id: "-" + Date.now()};
                        $scope.icons.push(newIcon);
                        $scope.uploadCache.icon = false;
                        $scope.selectDefaultImages({icon: newIcon.id})
                    }
                });

                $scope.$watch("icons.length", function (){
                   $scope.customIconsCount = $scope.icons.filter(function (icon) {
                        return !icon.global
                    }).length;
                });

            }


        })(preloadedGameData);

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);
